module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pFrontCover"
    }
  }), _c('a', {
    attrs: {
      "id": "pi"
    }
  }), _c('a', {
    attrs: {
      "id": "pii"
    }
  }), _c('a', {
    attrs: {
      "id": "piii"
    }
  }), _c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("First Mariner Books Edition 2000")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Afterword © 1999 by Paul Theroux")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 1998 by Paul Theroux")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data is available.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-618-00199-6 (pbk)")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Portions of this book have appeared in "), _c('em', [_vm._v("The New Yorker")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("The Afterword originally appeared, in different form, in The New "), _c('em', [_vm._v("York Times Book Review")]), _vm._v(" and the "), _c('em', [_vm._v("Observer")]), _vm._v(" in 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Lines by Derek Walcott are from "), _c('em', [_vm._v("Collected Poems")]), _vm._v(" 1948–1984 by Derek Walcott. Reprinted by permission of Farrar, Straus & Giroux, Inc. Lines from “The Whitsun Weddings” are from "), _c('em', [_vm._v("Collected Poems")]), _vm._v(" by Philip Larkin. Copyright © 1988, 1989 by the Estate of Philip Larkin. Reprinted by permission of Faber and Faber Ltd. The quotation from “Poetry of Departures” by Philip Larkin is reprinted from "), _c('em', [_vm._v("The Less Deceived")]), _vm._v(" by permission of Faber and Faber Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("eISBN 978-0-547-52619-5"), _c('br'), _vm._v("\nv2.0421")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0